import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ACCESS_DENIAL_STATEMENT, ACCESS_INTERNAL, DUPLICATE_STATEMENTS_CONFIRMATIONS_FLOW_PAGE_CONTAINER, POID_NOT_PRESENT_ERROR_MESSAGE } from '@app/constants/aem.constant';
import { CaasService } from '../../services/caas/caas.service';
import { AemUtil } from '@app/utils/aem.util';
import { environment } from '@environments/environment';
import { caas_dummy_content } from '@app/content/aem.content';

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  standalone: false,
  styleUrls: ['./login-error.component.scss']
})
export class LoginErrorComponent implements OnInit {
  accessDenialStatement: string = '';
  accessDenied: string | undefined | null = '';
  accessInternal: string | undefined | null = '';
  poidErrorHeading: string = '';
  poidErrorMessage: string = '';
  reason: string | null = '';

  constructor(
    private readonly caasService: CaasService,
    private readonly route: ActivatedRoute
  ) { }

  async ngOnInit() {
    this.reason = this.route.snapshot.queryParamMap.get('reason');
    if (this.reason === 'poid-missing' && environment.internal) {
      this.getPoidErrorContent();
    } else {
      await this.getCaasContent();
    }
  }

  async getCaasContent() {
    const response = this.caasService.getCaasData();
    if (response) {
      const container = response?.data?.[DUPLICATE_STATEMENTS_CONFIRMATIONS_FLOW_PAGE_CONTAINER];
      if (container?.item) {
        this.accessDenialStatement = AemUtil.getErrorMessagesFromMessages(container?.item?.messages, ACCESS_DENIAL_STATEMENT);
        this.accessDenied = AemUtil.getHeadingFromMessages(container?.item?.messages, ACCESS_DENIAL_STATEMENT)
        this.accessInternal = AemUtil.getLabelTextFromChildren(ACCESS_INTERNAL, container?.item?.additionalCta?.children)
      }
    }
  }

  getPoidErrorContent() {
    const response: any = caas_dummy_content;
    const container = response?.data?.[DUPLICATE_STATEMENTS_CONFIRMATIONS_FLOW_PAGE_CONTAINER];
    if (container?.item) {
      this.poidErrorHeading = AemUtil.getHeadingFromMessages(container?.item?.messages, POID_NOT_PRESENT_ERROR_MESSAGE) || '';
      this.poidErrorMessage = AemUtil.getErrorMessagesFromMessages(container?.item?.messages, POID_NOT_PRESENT_ERROR_MESSAGE);
    }
  }
}
